import { types } from 'mobx-state-tree'

export const SubscriptionGift = types
  .model('SubscriptionGift')
  .props({
    users: types.optional(types.array(types.frozen()), []),
    emails: types.optional(types.array(types.string), []),
    duration_mode: types.optional(types.enumeration(['permanent', 'custom']), 'permanent'),
    custom_duration_days: types.optional(types.maybeNull(types.number), 30),
    touched: types.optional(types.map(types.boolean), {}),
  })
  .views((self) => ({
    get errors() {
      const errs: Record<string, string | null> = {}
      errs.custom_duration_days =
        self.custom_duration_days != null && self.custom_duration_days > 0
          ? null
          : 'Duration must be greater than 0'
      return errs
    },
    get validEmails() {
      return self.emails.filter((e) => e.includes('@'))
    },
    get payload() {
      return {
        user_ids: self.users.map((u: any) => u.id),
        emails: self.emails.filter((e) => e.includes('@')),
        duration_days: self.duration_mode === 'permanent' ? null : self.custom_duration_days,
      }
    },
  }))
  .actions((self) => ({
    set(key: string, value: any) {
      ;(self as any)[key] = value
    },
    touch(key: string) {
      self.touched.set(key, true)
    },
  }))
